import { render, staticRenderFns } from "./layoutBase.vue?vue&type=template&id=15c7911a&scoped=true&"
import script from "./layoutBase.vue?vue&type=script&lang=js&"
export * from "./layoutBase.vue?vue&type=script&lang=js&"
import style0 from "./layoutBase.vue?vue&type=style&index=0&id=15c7911a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c7911a",
  null
  
)

export default component.exports